import React from 'react';
import { Splashes } from '../Splashes';
import { CtaButton } from '../CtaButton';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/6dNK1mwNMEWGWrHSY8w1mu/mockup_HERO.png';
const FEATURES = [{
  icon: '📄',
  label: '100% PDF'
}, {
  icon: '⚡',
  label: 'Acceso en 5 min'
}, {
  icon: '🎯',
  label: 'Todo nivel'
}, {
  icon: '📅',
  label: 'Todo el año'
}];
export function Hero({
  onCta
}: {
  onCta: () => void;
}) {
  return <section className="relative w-full overflow-hidden bg-ink px-5 py-8 sm:py-12" data-id="element-141" data-mp="mtirzqijb7l4">
      <Splashes data-id="element-142" data-mp="qub3kqevpokk" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-143" data-mp="qtszj7lz6623">
        <div className="inline-flex items-center gap-2 text-white" aria-label="Aula Baile Pro" data-id="element-144" data-mp="vmvwlppynxn1">
          <span className="h-2 w-2 rounded-full bg-lime" aria-hidden="true" data-id="element-145" data-mp="10kxdc3zwzkvc" />
          <span className="font-display text-xl uppercase tracking-[0.08em] sm:text-2xl" data-id="element-146" data-mp="15ll2sl8hvtng">Aula Baile</span>
          <span className="rounded border border-white/70 px-1.5 py-0.5 text-[10px] font-extrabold tracking-wider sm:text-xs" data-id="element-147" data-mp="1ako886se01vy">PRO</span>
        </div>
        

        <h1 className="mt-4 font-display text-[42px] leading-[0.9] sm:mt-5 sm:text-7xl" data-id="element-148" data-mp="4opuicfw2b8v">
          <span className="block text-white" data-id="element-149" data-mp="4r2hx54f1dtb">Todo tu año de Zumba.</span>
          <span className="mt-2 block text-magenta" data-id="element-150" data-mp="3vvaskg4d2jfe">Listo. Desde hoy.</span>
        </h1>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-151" data-mp="3rv09q2vgzyj4">
          El sistema N°1 para profes de Zumba: 6 tomos + 5 bonos para planificar, enseñar y
          renovar tus clases sin quedarte sin ideas.
        </p>

        <div className="relative mt-5 w-full max-w-[19rem] sm:mt-7 sm:max-w-md" data-id="element-152" data-mp="io8xyrxr8yeu">
          <img src={HERO_MOCKUP} alt="Caja del producto Mega Pack Zumba Pro 2026 con los 6 tomos y bonos" width={1024} height={1024} sizes="(min-width: 640px) 448px, 304px" loading="eager" fetchPriority="high" decoding="async" className="w-full rounded-2xl shadow-xl" data-id="element-153" data-mp="emvugoi4x7b3" />
        </div>

        <div className="mt-5 flex max-w-xl flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-154" data-mp="35l0jtxqton69">
          {FEATURES.map(feature => <span key={feature.label} className="inline-flex items-center gap-1" data-id="element-155" data-mp="2qvuert5b02qg">
              <span aria-hidden="true" data-id="element-156" data-mp="2vtme388a2r4o">{feature.icon}</span>
              {feature.label}
            </span>)}
        </div>

        <div className="mt-6 w-full max-w-md" data-id="element-157" data-mp="2hxippvk35d04">
          <CtaButton variant="lime" className="w-full" onClick={onCta} data-id="element-158" data-mp="2muslru1zcmwx">
            🔥 Quiero mi Megapack ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-medium text-white/50" data-id="element-159" data-mp="27z2wnn1hztnz">
            Acceso inmediato · Pago 100% seguro · Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}